import { useFormik } from "formik";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

// Redux
import {
  setMinistryValues,
  setDepartmentValues,
  setBranchValues,
} from "../../../../redux/slices/certify/certifySlice";

const MoreSearchField = ({ showCanvas, closeCanvas, searchMoreField }) => {
  const dispatch = useDispatch();

  const [departments, setDepartments] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [showBranchFilter, setShowBranchFilter] = useState(false);
  // const [ministryValues, setMinistryValues] = useState([]);
  // const [departmentValues, setDepartmentValues] = useState([]);

  const { ministries, ministryValues, departmentValues, branchValues } =
    useSelector((state) => ({
      ministries: state.utilsReducer.dropdownItems.ministries,
      ministryValues: state.certifyReducer.filters.ministryValues,
      departmentValues: state.certifyReducer.filters.departmentValues,
      branchValues: state.certifyReducer.filters.branchValues,
    }));

  const handleClose = () => {
    closeCanvas();
  };

  const handleSearch = () => {
    const newValues = {
      ministries_code: ministryValues.map((item) => Number(item.code)),
      department_ids: departmentValues.map((item) => item.id),
      branch_ids: branchValues.map((item) => item.id),
    };

    searchMoreField(newValues);
  };

  const handleResetField = () => {
    dispatch(setMinistryValues([]));
    dispatch(setDepartmentValues([]));
    dispatch(setBranchValues([]));
    const newValues = {
      ministries_code: [],
      department_ids: [],
      branch_ids: [],
    };

    searchMoreField(newValues);
  };

  const handleFilterMinistry = (value) => {
    dispatch(setMinistryValues(value));

    const departmentOptions = value.reduce((acc, ministry) => {
      return acc.concat(ministry.departments);
    }, []);

    setDepartments(departmentOptions);
  };

  const handleFilterDepartment = (value) => {
    const isSelectJKR = value.some((obj) => obj.short_form === "JKR");
    const selectedJKR = value.find((obj) => obj.short_form === "JKR");

    setShowBranchFilter(isSelectJKR);
    setBranchOptions(isSelectJKR ? selectedJKR.branches : []);
    dispatch(setDepartmentValues(value));
  };

  const handleFilterBranch = (value) => {
    dispatch(setBranchValues(value));
  };

  return (
    <Offcanvas show={showCanvas} onHide={handleClose} style={{ width: 310 }}>
      <Offcanvas.Body>
        <Offcanvas.Title className='mb-3'>Carian Tambahan</Offcanvas.Title>
        <Form autoComplete='off' noValidate style={{ fontSize: 12 }}>
          <Form.Group className='mb-3'>
            <Form.Label>Kementerian</Form.Label>
            <Select
              placeholder=''
              className='react-select-container'
              classNamePrefix='react-select'
              isMulti
              options={ministries || []}
              value={ministryValues}
              onChange={(value) => handleFilterMinistry(value)}
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>
          <Form.Group className='mb-3'>
            <Form.Label>Jabatan/Agensi</Form.Label>
            <Select
              placeholder=''
              className='react-select-container'
              classNamePrefix='react-select'
              isMulti
              options={departments || []}
              value={departmentValues}
              onChange={(value) => handleFilterDepartment(value)}
              noOptionsMessage={() => "Tiada pilihan"}
            />
          </Form.Group>

          {showBranchFilter && (
            <Form.Group className='mb-3'>
              <Form.Label>Cawangan</Form.Label>
              <Select
                placeholder=''
                className='react-select-container'
                classNamePrefix='react-select'
                isMulti
                options={branchOptions}
                value={branchValues}
                onChange={(value) => handleFilterBranch(value)}
                noOptionsMessage={() => "Tiada pilihan"}
              />
            </Form.Group>
          )}

          <div className='d-flex flex-column gap-3'>
            <Button
              variant='primary'
              className='flex-fill'
              onClick={handleSearch}
            >
              Cari
            </Button>
            <Button
              variant='light'
              className='flex-fill'
              onClick={handleResetField}
            >
              Set Semula
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MoreSearchField;
